(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('journal-article')) {
    customElements.define(
      'journal-article',
      class extends HTMLElement {
        connectedCallback() {
          const prose = this.querySelector('[data-journal-prose]');
          const source = this.querySelector('[data-journal-frames]');
          if (!prose || !source) return;

          const imagePath = (image) => new URL(image.currentSrc || image.src, location.href).pathname;
          const usedImages = new Set([...prose.querySelectorAll('img')].map(imagePath));
          const hero = document.querySelector('.journal-hero__image');
          if (hero) usedImages.add(imagePath(hero));

          const frames = [...source.children].filter((frame) => {
            const image = frame.querySelector('img');
            if (!image || frame.querySelector('video')) return true;
            const path = imagePath(image);
            if (usedImages.has(path)) return false;
            usedImages.add(path);
            return true;
          });
          const paragraphs = [...prose.children].filter(
            (block) =>
              block.matches('p, ul, ol, blockquote, div') &&
              block.textContent.trim() &&
              !block.querySelector('img, video, iframe'),
          );

          const insertionPoints = paragraphs.map((paragraph) => paragraph.nextSibling);
          frames.forEach((frame, index) => {
            const position = Math.ceil(((index + 1) * paragraphs.length) / (frames.length + 1));
            const paragraph = paragraphs[position - 1];
            if (paragraph) prose.insertBefore(frame, insertionPoints[position - 1]);
            else prose.append(frame);
          });
          source.remove();

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.querySelectorAll('video[autoplay]').forEach((video) => {
              video.removeAttribute('autoplay');
              video.pause();
            });
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
